import React from "react";
import {
    Checkbox as BaseCheckbox,
    CheckboxGroup as BaseCheckboxGroup,
    CheckboxGroupProps,
    CheckboxProps,
    Label,
    Text,
    composeRenderProps,
} from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { RichText } from "../RichText";
import { Svg } from "../Svg";
import { FieldError, FieldProps } from "./common";

import styles from "./inputs.module.scss";

export function Checkbox({ children, className, ...props }: CheckboxProps) {
    return (
        <BaseCheckbox
            {...props}
            className={composeRenderProps(className, (cn) =>
                concatClassNames([cn, styles.fieldWrapper]),
            )}
        >
            {composeRenderProps(children, (children, _) => (
                <>
                    <span className={styles.checkbox}>
                        <Svg aria-hidden name="check" />
                    </span>
                    {children}
                </>
            ))}
        </BaseCheckbox>
    );
}

export function CheckboxGroup({
    label,
    description,
    children,
    className,
    ...props
}: FieldProps & CheckboxGroupProps) {
    return (
        <BaseCheckboxGroup
            {...props}
            className={composeRenderProps(className, (cn) =>
                concatClassNames([cn, styles.fieldGroup]),
            )}
            isInvalid={props.errorMessage ? true : undefined}
        >
            {composeRenderProps(children, (children) => (
                <>
                    {description && (
                        <Text slot="description">
                            <RichText value={description} />
                        </Text>
                    )}
                    {label && (
                        <Label className={styles.groupLabel}>{label}</Label>
                    )}
                    {children}
                    <FieldError>{props.errorMessage}</FieldError>
                </>
            ))}
        </BaseCheckboxGroup>
    );
}
